import styled from 'styled-components';

export const StyledListItem = styled.li`
  display: flex;
  align-items: center;
  background: transparent;
  margin-bottom: 12px;
  break-inside: avoid;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const ItemValuePanel = styled.div<{ background?: string }>`
  display: flex;
  align-items: center;
  height: 24px;
  padding: 8px;
  border-radius: 8px;
  background: ${({ background }) => background ? `${background}` : '#ffffff26'};
  cursor: pointer;
  margin-left: 8px;
`;

export const IconContainer = styled.div<{ size?: number, background?: string }>`
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ background }) => background ? `${background}` : '#ffffff26'};
`;

IconContainer.defaultProps = {
  size: 24,
};

export const Icon = styled.img`
  width: 17px;
  height: 17px;
`;

export const TooltipText = styled.div`
  opacity: 0;
  font-size: 14px;
  background-color: #262626;
  color: white;
  text-align: center;
  border-radius: 8px;
  padding: 8px;
  transition-duration: 0.5s;
  position: fixed;
  z-index: 50;
`;

export const ItemText = styled.div<{ lineClamp?: number; isTitle?: boolean; maxWidth?: string }>`
  width: 100%;
  overflow: hidden;
  display: -webkit-box;
  font-size: ${({ isTitle }) => (isTitle ? '12px' : '16px')};
  max-width: ${({ maxWidth }) => maxWidth || '100%'};
  line-height: 14px;
  -webkit-line-clamp: ${({ lineClamp }) => lineClamp};
  -webkit-box-orient: vertical;
`;

ItemText.defaultProps = {
  lineClamp: 1,
};

export const ItemTextContainer = styled.div`
  position: relative;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  gap: 9px;

  & ${ItemText}:hover + ${TooltipText} {
    opacity: 1;
    transition-delay: 1s;
  }
`;
